import { render, staticRenderFns } from "./CamujalView.vue?vue&type=template&id=0dcba430&"
import script from "./CamujalView.vue?vue&type=script&lang=js&"
export * from "./CamujalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports